import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Checkout.css'
import CheckoutProduct from './CheckoutProduct';
import { useStateValue } from './StateProvider';
import Subtotal from './Subtotal';
import './MediaQuery.css';
import axios from 'axios';
import { getBasketTotal } from './reducer';
import { useHistory } from 'react-router-dom';

function Checkout() {
    const [{ basket, user, deliveryfees}, dispatch] = useStateValue();
    const [fname, setFname] = useState('');
    const [lname, setLname] = useState('');
    const [address, setAddress] = useState('');
    const [phone, setPhone] = useState('');
    /*const [fname, setFname] = useState('');
    const [address, setAddress] = useState('');
    const [pcode, setPcode] = useState('');
    const [lname, setLname] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [checkedterms, setCheckedterms] = useState(false);
    const [checkedpolicy, setCheckedpolicy] = useState(false);*/
    const history = useHistory();
    const [counter, setCounter] = useState(0);

    useEffect(() => {
    
        if(user.length === 0 && basket.length === 0){
            history.push('/');
        } 

    }, [])

    function useInterval(callback, delay) {

        const savedCallback = useRef();
      
        // Remember the latest callback.
        useEffect(() => {
          savedCallback.current = callback;
        }, [callback]);
      
        // Set up the interval.
        useEffect(() => {
          let id = setInterval(() => {
            savedCallback.current();
          }, delay);
          return () => clearInterval(id);
        }, [delay]);

        
    }

    useInterval(() => {
        setCounter(counter + 1);
    }, 1000);

    useEffect(() => {
        if(counter === 5){
            document.getElementById("242").style.display = "none";
            document.getElementById("777").style.display = "none";
            document.getElementById("787").style.display = "none";
            document.getElementById("593").style.display = "none";
            document.getElementById("247").style.display = "none";
            /*document.getElementById("444").style.display = "none";
            document.getElementById("424").style.display = "none";*/
        }
    }, [counter])
    

    /*function toggle(value){
        return !value;
    }*/

    const onSubmit = () => {

        if(basket.length === 0){
            document.getElementById("242").style.display = "block";
            setCounter(0);
        }else if(user.length === 0){
            
            dispatch({
                type: "SET_CHECHUSER",
                checkuser: true,
            });

            history.push('/signin');

        }else{

            var email = '';

            user.map(item => {
                setFname(item.first_name)
                setLname(item.last_name)
                setAddress(item.address)
                setPhone(item.phone_number)
                email = item.email
            })

            axios
                .get('https://toycityzimbabwe.com/backend/getUser.php',{params: { email }} )
                .then(res => {
                    dispatch({
                        type: 'SET_USER',
                        user: res.data
                    })
                })
                .catch( error => {
                    console.log(error)
                });
            
            document.getElementById("007").style.display= "flex";
            document.getElementById("008").style.display= "block";
            document.getElementById("009").style.display= "none";
            document.getElementById("010").style.display= "block";
        }

    }

    const onFinish = () => {

        if(fname === ''){
            document.getElementById("777").style.display = "block";
            document.getElementById("__777").style.border = "1px solid red";
            setCounter(0);
        }else if(lname === ''){
            document.getElementById("787").style.display = "block";
            document.getElementById("__787").style.border = "1px solid red";
            setCounter(0);
        }else if(address === ''){
            document.getElementById("593").style.display = "block";
            document.getElementById("__593").style.border = "1px solid red";
            setCounter(0);
        }else if(phone === ''){
            document.getElementById("247").style.display = "block";
            document.getElementById("__247").style.border = "1px solid red";
            setCounter(0);
        }else if(basket.length === 0){
            document.getElementById("242").style.display = "block";
            setCounter(0);
        }else{
            var firstName, lastName, adDress, phoneNumber, email = '';
            
            user.map(item => {
                firstName = item.first_name
                lastName = item.last_name
                adDress = item.address
                phoneNumber = item.phone_number
                email = item.email
            })

            var _fname = fname;
            var _lname = lname;
            var _address = address;
            var _phone = phone;

            if(fname !== firstName){
                axios
                    .get('https://toycityzimbabwe.com/backend/updateFname.php',{params: { email, _fname }} )
                    .then(res => {
                    })
                    .catch( error => {
                        console.log(error)
                    });

            }else if(lname !== lastName){
                axios
                    .get('https://toycityzimbabwe.com/backend/updateLname.php',{params: { email, _lname }} )
                    .then(res => {
                    })
                    .catch( error => {
                        console.log(error)
                    });

            }else if(address !== adDress){
                axios
                    .get('https://toycityzimbabwe.com/backend/updateAddress.php',{params: { email, _address }} )
                    .then(res => {
                    })
                    .catch( error => {
                        console.log(error)
                    });

            }else if(phone !== phoneNumber){
                axios
                    .get('https://toycityzimbabwe.com/backend/updatePhone.php',{params: { email, _phone }} )
                    .then(res => {
                    })
                    .catch( error => {
                        console.log(error)
                    });
            }

            handleOrder();
        }

    }

    /**/function handleOrder(){
        var cid, email = '';
        user.map(item =>{
            cid = item.client_id;
            email = item.email
        })

        dispatch({
            type: "SET_CDETAILS",
            item:{
                cid: cid,
                fname: fname,
                lname: lname,
                address: address,
                phone: phone,
                email: email
            },
        });

        var bQnt = basket.length
        var total = getBasketTotal(basket) + deliveryfees

        axios
            .get('https://toycityzimbabwe.com/backend/postSendEmailOrder.php',{params: {bQnt, total, basket, email, fname, lname, address, phone}} )
            .then(res => {
               //handleItem(res.data)
            })
            .catch( error => {
                console.log(error)
            });

        axios
            .get('https://toycityzimbabwe.com/backend/postOrder.php',{params: {cid, bQnt, total}} )
            .then(res => {
               handleItem(res.data)
            })
            .catch( error => {
                console.log(error)
            });
    }

    function handleItem(oderId){
        var oid = '';
        oderId.map(item =>{
            oid = item.order_id
        })


        basket.map(item => {
            var img = item.img
            var price = item.price
            var qnt = item.qnt
            var name = item.title
            var prodid = item.id

            axios
            .get('https://toycityzimbabwe.com/backend/postItems.php',{params: {oid, price, qnt, img, name, prodid}} )
            .then(res => {
               //console.log(res.data)
            })
            .catch( error => {
                console.log(error)
            });
        })

        history.push('/receipt')
    } 

    return (
        <div className="checkout">
            <h1>My Shopping Basket</h1>
            <div className='checkout__error' id='242'>
                <label id='242'>The basket is empty</label>
            </div>
            {basket.map(item => (
                <CheckoutProduct 
                    id = {item.id}
                    title={item.title}
                    price={item.price} 
                    img={item.img}
                    qnt={item.qnt}
                />
            ))}
            <Subtotal/>
            <div className="checkout__details">
                <h1 id='008' className='display_none'>Shipping Address</h1>
                <div id='007' className="checkout__dtails">
                    <input type="text" id='__777' value={fname} onChange={e => setFname(e.target.value)} placeholder="First Name"></input>
                    <div className='signup__error' id='777'><label id='424'>First name required</label></div>
                    <input type="text" id='__787' value={lname} onChange={e => setLname(e.target.value)} placeholder="Last Name"></input>
                    <div className='signup__error' id='787'><label id='424'>Last name required</label></div>
                    <input type="text" id='__593' value={address} onChange={e => setAddress(e.target.value)} placeholder="Address"></input>
                    <div className='signup__error' id='593'><label id='424'>Address required</label></div>
                    <input type="text" id='__247' value={phone} onChange={e => setPhone(e.target.value)} placeholder="Phone Number"></input>
                    <div className='signup__error' id='247'><label id='424'>Phone number required</label></div>
                </div>
                {/* <div className='checkout__error' id='444'>
                    <label id='444'>Fill all fields</label>
                </div>
                <div className="checkout__dcolumn">
                    <div className="checkout__drow">
                        <input type="text" value={fname} onChange={e => setFname(e.target.value)} placeholder="First Name"></input>
                    </div>
                    <div className="checkout__drow">
                        <input type="text" value={lname} onChange={e => setLname(e.target.value)} placeholder="Last Name"></input>
                    </div>
                </div>
                <div className="checkout__dcolumn">
                    <div className="checkout__drow">
                        <input type="text" value={address} onChange={e => setAddress(e.target.value)} placeholder="Address"></input>
                    </div>
                    <div className="checkout__drow">
                        <input type="text" value={pcode} onChange={e => setPcode(e.target.value)} placeholder="Postcode"></input>
                    </div>
                </div>
                <div className="checkout__dcolumn">
                    <div className="checkout__drow">
                        <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email"></input>
                    </div>
                    <div className="checkout__drow">
                        <input type="text" value={phone} onChange={e => setPhone(e.target.value)} placeholder="Phone"></input>
                    </div>
                </div>
            </div>
            <div className="checkout__bottom">
                <div className='checkout__error' id='424'>
                    <label id='424'>Must check the boxes</label>
                </div>
                <div className="checkout__bottoml">
                    <div className="checkout__binput">
                        <input type="checkbox" checked={checkedterms} onChange={() => setCheckedterms(toggle)}></input>
                        <div className="checkout__blabel">
                            <label>I agree with the terms and conditions</label>
                            <Link to='/terms-and-conditions'>
                                <label className='labelmore'>Read more </label>
                            </Link>
                        </div>
                    </div>
                    <div className="checkout__binput">
                        <input type="checkbox" checked={checkedpolicy} onChange={() => setCheckedpolicy(toggle)}></input>
                        <div className="checkout__blabel">
                            <label>I have read and I accept the privacy policy</label>
                            <Link to='/privacy-policy'>
                                <label className='labelmore'>Read more </label>
                            </Link>
                        </div>
                    </div>
                </div>*/}
                <div className="checkout__bottomr">
                    <Link to="/">
                        <button><span class="iconify" data-icon="eva:arrow-back-fill"></span> back to shop</button>
                    </Link>
                    <Link>
                        <button id='009' onClick={onSubmit}>BUY NOW<span class="iconify" data-icon="eva:arrow-forward-fill"></span></button>
                    </Link>
                    <Link>
                        <button id='010' className='display_none' onClick={onFinish}>FINISH ORDER <span class="iconify" data-icon="eva:arrow-forward-fill"></span></button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default Checkout;
